import { useTranslations } from 'next-intl';
import Link from 'next/link';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { linkOverlay } from '@flipster/styled-system/patterns';

import { GlossaryPageGlossaryTermFragment } from '../query.generated';
import ShareTermButton from './share-term-button';

const TermListItem = ({ glossaryTerm }: { glossaryTerm: GlossaryPageGlossaryTermFragment }) => {
  const t = useTranslations();
  const glossaryTermPageUrl = `/glossary/${glossaryTerm.slug}`;

  return (
    <article
      id={glossaryTerm.slug ?? undefined}
      className={css({
        pos: 'relative',
        display: 'block',
        py: 18,
        px: 16,
        bgColor: 'background.default.level-1',
        rounded: 4,
      })}
    >
      <Link
        className={linkOverlay()}
        tabIndex={-1}
        href={glossaryTermPageUrl}
        aria-hidden
        aria-label={t('Autogen_common.r251126.s_Learn_more_about_glossaryTerm_name', {
          glossaryTerm_name: glossaryTerm.name,
        })}
      />
      <h2 className={css({ textStyle: 'Title/M', mb: 6, color: 'inverse.white' })}>
        {glossaryTerm.name}
        <ShareTermButton glossaryTerm={glossaryTerm} />
      </h2>
      <p className={css({ textStyle: 'Text/L/Regular', mb: 10, color: 'content.default.level-5' })}>
        {glossaryTerm.summary}
      </p>
      <span className={css({ textStyle: 'Text/S/Underline', color: 'content.default.level-2' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Learn_more' />
      </span>
    </article>
  );
};

export default TermListItem;
